import TableCell from "../../common/table/tableCell";

const Row = (props: any) => {
  return (
    <tr className="tablePharmacies">
      <TableCell label={props.report.campaign} class="column-width" />
      <TableCell label={props.report.name} />
      <TableCell label={props.report.surveyAnswers} />
    </tr>
  );
};

export default Row;
